import { formatISO } from 'date-fns';

const trackWithCommonData = (payload: any) => ({
  ...payload,
  url: location.href,
  eventTimestamp: formatISO(new Date()),
  source: 'dealer',
});

export default trackWithCommonData;
